export default {
  EXTEND_REGISTRATION_REQUEST: "EXTEND_REGISTRATION_REQUEST",
  EXTEND_REGISTRATION_SUCCESS: "EXTEND_REGISTRATION_SUCCESS",
  EXTEND_REGISTRATION_FAILURE: "EXTEND_REGISTRATION_FAILURE",
  DEREGISTER_REGISTRATION_REQUEST: "DEREGISTER_REGISTRATION_REQUEST",
  DEREGISTER_REGISTRATION_SUCCESS: "DEREGISTER_REGISTRATION_SUCCESS",
  DEREGISTER_REGISTRATION_FAILURE: "DEREGISTER_REGISTRATION_FAILURE",
};
